export default __webpack_public_path__ + "static/media/teamTino.7b4bac0b.jpg";